import React, { Component } from 'react';
import { Breadcrumb, Button, DatePicker, Divider, Select, message } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import RuleReportGrid from './RuleReportGrid';
import ResolveRuleReportModalDialog from './ResolveRuleReportModalDialog';
import OperationRecordDialog from '../../../common/operationRcd/components/OperationRecordDialog';
import StatReportModalDialog from './StatReportModalDialog';
import '../../FundMonitoring.css';

const Option = Select.Option;

class RuleReportDashboard extends Component {
    state = { statReportVisible: false };
    componentDidMount() {
        this.props.loadRuleMaster();
        const { date, ruleCategory, fund } = this.props.ruleReportQueryFields;
        this.props.loadRuleReport(date, ruleCategory, fund);
    }

    componentDidUpdate() {
        const {
            loadRuleReportActionStatus,
            ruleReportActionResp,
            generateRuleReportActionStatus,
            generateRuleReportActionResp,
            updateRuleReportActionStatus,
            updateRuleReportActionResp,
            statReportActionStatus,
            statReportActionResp,
        } = this.props;

        if (loadRuleReportActionStatus === ACTION_STATUS.SUCCESS) this.props.initLoadRuleReportActionStatus();
        if (loadRuleReportActionStatus === ACTION_STATUS.ERROR) {
            message.error((ruleReportActionResp && ruleReportActionResp.respMessage) || 'Query Rule Report failed.');
            this.props.initLoadRuleReportActionStatus();
        }
        if (generateRuleReportActionStatus === ACTION_STATUS.SUCCESS) {
            message.success('Rule Report generated successfully.');
            this.props.initGenerateRuleReportActionStatus();
            const { date, ruleCategory, fund } = this.props.ruleReportQueryFields;
            this.props.loadRuleReport(date, ruleCategory, fund);
        }
        if (generateRuleReportActionStatus === ACTION_STATUS.ERROR) {
            const respMsg = (generateRuleReportActionResp && generateRuleReportActionResp.respMessage) || 'Generate Rule Report failed.';
            const respCode = generateRuleReportActionResp && generateRuleReportActionResp.respCode;
            if (respCode === 'F4001' || (respMsg && respMsg.includes('has been generated already'))) {
                message.warning(respMsg);
            } else {
                message.error(respMsg);
            }
            this.props.initGenerateRuleReportActionStatus();
        }
        if (updateRuleReportActionStatus === ACTION_STATUS.SUCCESS) {
            message.success('Rule Report resolved successfully.');
            this.props.initUpdateRuleReportActionStatus();
            this.props.closeResolveRuleReportModal();
            const { date, ruleCategory, fund } = this.props.ruleReportQueryFields;
            this.props.loadRuleReport(date, ruleCategory, fund);
        }
        if (updateRuleReportActionStatus === ACTION_STATUS.ERROR) {
            message.error((updateRuleReportActionResp && updateRuleReportActionResp.respMessage) || 'Resolve Rule Report failed.');
            this.props.initUpdateRuleReportActionStatus();
        }
        if (statReportActionStatus === ACTION_STATUS.ERROR) {
            message.error((statReportActionResp && statReportActionResp.respMessage) || 'Generate StatReport failed.');
            this.props.initStatReportActionStatus();
        }
    }

    change = (name, value) => this.props.ruleReportInputChange({ name, value });
    opRcdCustomColumns = ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'];

    resolveBtnOnClicked = () => {
        const { selectedRuleReportArray } = this.props;
        if (!selectedRuleReportArray || selectedRuleReportArray.length === 0) {
            message.warning('Please choose at least one Rule Report record');
            return;
        }
        this.props.openResolveRuleReportModal(selectedRuleReportArray);
    };

    operationRecordBtnOnClicked = () => {
        const { selectedRuleReportArray } = this.props;
        const queryFields = { module: 'RuleReport' };
        if (selectedRuleReportArray && selectedRuleReportArray.length > 0) {
            queryFields.dataId = selectedRuleReportArray.map(item => item.id).join(',');
        }
        this.props.doOperationRecordAction({
            action: 'OPEN_AND_QUERY',
            queryFields,
            customColumns: this.opRcdCustomColumns,
        });
    };

    render() {
        const { date, ruleCategory, fund, showAll } = this.props.ruleReportQueryFields;
        const loading = this.props.loadRuleReportActionStatus === ACTION_STATUS.LOGINING;
        const generating = this.props.generateRuleReportActionStatus === ACTION_STATUS.LOGINING;
        return <div className="ruleReportWrapper">
            <div className="breadcrumbWrapper"><Breadcrumb><Breadcrumb.Item>Fund Monitoring</Breadcrumb.Item><Breadcrumb.Item>Rule Report</Breadcrumb.Item></Breadcrumb></div>
            <div className="operationBar">
                <DatePicker size="small" allowClear={false} placeholder="Report Date" value={date} style={{ marginLeft: 10 }} onChange={value => this.change('date', value)} />
                <Select size="small" showSearch value={ruleCategory} style={{ width: 150, marginLeft: 10 }} onChange={value => this.change('ruleCategory', value)}>
                    <Option value="All">All</Option><Option value="Disclosure">Disclosure</Option><Option value="PPM">PPM</Option><Option value="Internal Limit">Internal Limit</Option>
                </Select>
                <Select size="small" showSearch value={fund} style={{ width: 140, marginLeft: 10 }} onChange={value => this.change('fund', value)}>
                    <Option value="All">All</Option><Option value="PMSF">PMSF</Option><Option value="PCF">PCF</Option><Option value="VCC">VCC</Option>
                </Select>
                <Button type="primary" size="small" loading={generating} style={{ marginLeft: 10 }} onClick={() => this.props.generateRuleReport(date, ruleCategory, fund)}>Generate</Button>
                <Button size="small" type={showAll ? 'primary' : 'default'} style={{ marginLeft: 10 }} onClick={() => this.change('showAll', !showAll)}>Show All</Button>
                <Button size="small" style={{ marginLeft: 10 }} onClick={() => this.setState({ statReportVisible: true })}>StatReport</Button>
                <Button type="primary" size="small" style={{ marginLeft: 10 }} onClick={this.resolveBtnOnClicked}>Resolve</Button>
                <Divider type="vertical" />
                <Button type="primary" size="small" loading={loading} onClick={() => this.props.loadRuleReport(date, ruleCategory, fund)}>Refresh</Button>
                <Button type="primary" size="small" style={{ marginLeft: 10 }} onClick={this.operationRecordBtnOnClicked}>Operation Record</Button>
            </div>
            <div className="ruleReportGrid"><RuleReportGrid {...this.props} /></div>
            <ResolveRuleReportModalDialog {...this.props} />
            <OperationRecordDialog {...this.props} />
            <StatReportModalDialog
                visible={this.state.statReportVisible}
                loading={this.props.statReportActionStatus === ACTION_STATUS.LOGINING}
                report={this.props.statReportActionResp && this.props.statReportActionResp.data}
                onCancel={() => this.setState({ statReportVisible: false })}
                onGenerate={this.props.generateStatReport}
            />
        </div>;
    }

}

export default RuleReportDashboard;
